module.exports = "pegasus/assets/presentation-card.png";